import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ChatbotPage from '../../chatbot/ChatbotPage';
import ChatbotStartGuidePage from '../../chatbot/ChatbotStartGuide';
import { CHATBOT_PERMISSION } from '../../firewall/permissions';
import withPermissionRedirect from '../../wrappers/withPermissionRedirect';
import Error404 from '../error-pages/Error404';

const ChatbotWithAccess = withPermissionRedirect(CHATBOT_PERMISSION, '/chatbot/start-guide')(ChatbotPage);

function ChatbotRoutes() {
  return (
    <Routes>
      <Route index element={<ChatbotWithAccess />} />
      <Route path="start-guide" element={<ChatbotStartGuidePage />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}

export default ChatbotRoutes;
